module.exports = __webpack_public_path__ + "assets/1.51948b97.png";